import { useState, useEffect } from 'react';
import { throttle } from 'lodash-es';
const useScrollbar = (ref: React.RefObject<HTMLDivElement>, options: { horizontal?: boolean; vertical?: boolean; } = {}) => {
  const [hasXScrollbar, setHasXScrollbar] = useState(false);
  const [hasYScrollbar, setHasYScrollbar] = useState(false);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const checkScrollbar = () => {
      if (ref.current) {
        const { horizontal, vertical } = options;
        horizontal && setHasXScrollbar(ref.current.scrollWidth > ref.current.clientWidth);
        vertical && setHasYScrollbar(ref.current.scrollHeight > ref.current.clientHeight);
      }
    };
    const handleScroll = throttle(() => {
      if (ref.current) {
        const { horizontal, vertical } = options;
        horizontal && setScrollLeft(ref.current.scrollLeft);
        vertical && setScrollTop(ref.current.scrollTop);
      }
    }, 500);
    // 初始检查是否有滚动条
    checkScrollbar();
    window.addEventListener('resize', checkScrollbar);
    if (ref.current) {
      ref.current.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener('scroll', handleScroll);
      }
      window.removeEventListener('resize', checkScrollbar);
    };
  }, [ref, options]);

  return { hasXScrollbar, scrollLeft, hasYScrollbar, scrollTop };
};

export default useScrollbar;